import { ReportType } from '../../schema/p4types';
import * as printFunctions from '../../../actions/customer/OverdueAccountAction';
import { DocumentEntityType } from '../../../@types/entityTypes';
import printCustomerOverdueAccountSingleMutation from '../../mutations/customer/PrintCustomerOverdueAccountSingleMutation.graphql';
import printCustomerOverdueAccountRangeMutation from '../../mutations/customer/PrintCustomerOverdueAccountRangeMutation.graphql';

const OverdueAccount: DocumentEntityType = {
  printFunctions: printFunctions,
  generate: printCustomerOverdueAccountSingleMutation,
  generateRange: printCustomerOverdueAccountRangeMutation,
  configuration: {
    title: 'Manual Credit Control',
    reportType: ReportType.CustomerOverdueAccount,
    field: 'overdueAccountDefault',
    customerField: 'customerOverdueAccountDefault',
    receiveFlag: 'receiveOverdueAccount',
  },
};

export default OverdueAccount;
